import Table from './merge-table.vue';
import TableTd from './td.vue';
import TableTr from './tr.vue';

export {TableTd, TableTr};
export default Table;


// WEBPACK FOOTER //
// ./src/components/merge-table/index.js